import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, FormLabel } from "@mui/material";
import { DateRange } from "@mui/icons-material";
import { useQueryNotifications } from "../../../../queries/UseQueryNotifications";
import { useCustomerAttribute } from "../../../../queries/attributes/UseCustomerAttribute";
import SideSheetCheckbox from "../../../side-sheet/side-sheet-checkbox/SideSheetCheckbox";
import { useCustomDurationDialogState, CustomDurationDialogValues, CustomDurationDialog, bindCustomDurationDialog  } from "../../../custom-duration-dialog/CustomDurationDialog";
import CustomDurationUtils, { DurationOptionEnum } from "../../../custom-duration-dialog/CustomDurationUtils";

export type AlarmDashboardViewOptionsProps = {
    groupID: number | undefined;
    durationOptions: CustomDurationDialogValues;
    onDurationChanged: (values: CustomDurationDialogValues) => void;
    showText: boolean;
    onShowTextChanged: (checked: boolean) => void;
    showEmail: boolean;
    onShowEmailChanged: (checked: boolean) => void;
    showVoice: boolean;
    onShowVoiceChanged: (checked: boolean) => void;
};


export function AlarmDashboardViewOptions({
    groupID,
    durationOptions,
    onDurationChanged,
    showText,
    onShowTextChanged,
    showEmail,
    onShowEmailChanged,
    showVoice,
    onShowVoiceChanged
}: AlarmDashboardViewOptionsProps) {


    const [durationLabel, setDurationLabel] = useState(CustomDurationUtils.getCustomDurationLabel(DurationOptionEnum.OneDay, true));

    const { t } = useTranslation();
    
    const durationDialog = useCustomDurationDialogState();    

    const {data: allowVoiceAlarmAttribute } = useQueryNotifications(useCustomerAttribute)({
        groupID: groupID ?? -1,
        name: 'allow voice alarm',
        enabled: groupID !== undefined
    });

    const allowVoiceAlarm = allowVoiceAlarmAttribute?.attributeValue.toLowerCase() === 'true';


    async function onCustomDuration() {
        const result = await durationDialog.open(durationOptions);

        if (result.reason === "ok") {
            const values = result.values as CustomDurationDialogValues;

            setDurationLabel(CustomDurationUtils.getCustomDurationLabel(result.values?.option as DurationOptionEnum, true));
            onDurationChanged(values);
        }
    }

    useEffect(() => {

        setDurationLabel(CustomDurationUtils.getCustomDurationLabel(durationOptions.option as DurationOptionEnum, true));

    }, [
        durationOptions,
        setDurationLabel
    ])

    return (

        <>

            <FormLabel component="legend">
                {t('customDuration.duration')}
            </FormLabel>
            <Button variant='text' 
                startIcon={<DateRange/>} 
                sx={{justifyContent: 'flex-start'}}
                onClick={onCustomDuration}>
                    {durationLabel}
            </Button>



            <FormLabel component="legend">
                {t('alarmDashboard.notificationTypes')}
            </FormLabel>

            <SideSheetCheckbox  
                label={t('alarmDashboard.text')}  
                checked={showText}
                onChange={(checked) => onShowTextChanged(checked)}
                
                />

            <SideSheetCheckbox  
                label={t('alarmDashboard.email')}  
                checked={showEmail}
                onChange={(checked) => onShowEmailChanged(checked)}
                sx={{marginTop: '0 ! important'}}
                />

            {
            allowVoiceAlarm && <SideSheetCheckbox  
                label={t('alarmDashboard.voiceCallout')}  
                checked={showVoice}
                onChange={(checked) => onShowVoiceChanged(checked)}
                sx={{marginTop: '0 ! important'}}
                />
            }

            <CustomDurationDialog hideDefault={true}
                    value={durationOptions}
                {...bindCustomDurationDialog(durationDialog)}
            />
        </>
    );
}

